module.exports = __webpack_public_path__ + "static/media/motto_background.3e274afc.png";